<div #wrapper (click)="onClick($event)" style=""><ng-content></ng-content></div>
